// extracted by mini-css-extract-plugin
export default {"container":"OverflowTooltip__container___11fWM","childrenWrapper":"OverflowTooltip__children-wrapper___2QQiu"};